<dx-data-grid id="gridActivityContainer" [dataSource]="TSvc.trashMachineActivityDataSource" [showBorders]="true"
    [remoteOperations]="true" [rowAlternationEnabled]="true" [columnHidingEnabled]="true" [columnAutoWidth]="true" class="p-1">
    <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>
    <dxi-column dataField="When" [caption]="'when' | translateWithFallback" dataType="datetime" format="dd-MM-yyyy hh:mm:ss.SSS" sortOrder="desc">
    </dxi-column>
    <dxi-column dataField="ActivityType"  [caption]="'type' | translateWithFallback" dataType="string" [hidingPriority]="2">
    </dxi-column>
    <dxi-column dataField="InfoLevel"  [caption]="'level' | translateWithFallback" dataType="string" [hidingPriority]="3">
    </dxi-column>
    <dxi-column dataField="Text"  [caption]="'text' | translateWithFallback" dataType="string" [hidingPriority]="1"></dxi-column>
    <dxi-column dataField="Tags" [caption]="'tags' | translateWithFallback" dataType="string" [allowFiltering]="false" [allowSorting]="false" [hidingPriority]="0">
    </dxi-column>

    <dxo-filter-panel [visible]="true"></dxo-filter-panel>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-search-panel [visible]="true"></dxo-search-panel>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-scrolling rowRenderingMode="virtual" mode="infinite"> </dxo-scrolling>
    <dxo-paging [pageSize]="25"> </dxo-paging>
    <dxo-pager [visible]="true" [showInfo]="true" [showNavigationButtons]="true">
    </dxo-pager>
</dx-data-grid>
